// PricingPage.js
import React from 'react';
import MainLayout from '../layouts/MainLayout';
import '../styles/Think5WhysPricing.css';

const Think5WhysPricing = () => {
  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Pricing</h2>
      </div>
      <div className="pricing-container">
        {/* Personal Plans */}
        <div className="plan">
          <h3>Personal Usage - Free</h3>
          <p>(This is For individuals who want to explore basic features.)</p>
          <h3>Personal Monthly (Billed Yearly)</h3>
          <p>This is Monthly subscription with Annual Billing for Personal Use.</p>
          <button className="subscribe-button">Subscribe</button>
          <h3>Personal Yearly</h3>
          <p>Annual Subscription Plan for Personal Use.</p>
          <button className="subscribe-button">Subscribe</button>
        </div>

        {/* Corporate Plans */}
        <div className="plan">
          <h3>Corporate Use</h3>
          <p>Customized plans for Corporate Usage. Contact us for a Quote.</p>
          <button className="quote-button">Ask For Quote</button>
          <h3>Corporate Monthly (Billed Yearly)</h3>
          <p>Monthly Subscription with annual Billing for Corporate use.</p>
          <button className="subscribe-button">Subscribe</button>
          <h3>Corporate Yearly</h3>
          <p>Annual Subscription for Corporate use.</p>
          <button className="subscribe-button">Subscribe</button>
        </div>

        {/* Free Plans */}
        <div className="plan">
          <h3>Job Posting & Searching - Free</h3>
          <p>Post and search for job opportunities at no cost.</p>
        </div>

        {/* Customization Options */}
        <div className="plan">
          <h3>White Label</h3>
          <p>Get a personalized white-label solution for your brand. Contact us for pricing.</p>
          <button className="quote-button">Quote For Price</button>
        </div>
        <div className="plan">
          <h3>Customization Label</h3>
          <p>Customize the platform with your label. Contact us for pricing.</p>
          <button className="quote-button">Quote For Price</button>
        </div>
      </div>
    </MainLayout>
  );
};

export default Think5WhysPricing;
